// jQuery(document).ready(function ($) {

    if ( $('#question-1').length > 0) {
        // Variables to store the question and result elements
        var $question1 = $('#question-1');
        var $question2 = $('#question-2');
        var $resultStrength = $('#result-strength');
        var $resultInjury = $('#result-injury');
        var $resultPhysio = $('#result-physio');

        // Event handlers for answering the first question
        $('#question-1-yes').on('click', function() {
            $question1.hide();
            $question2.show();
        });

        $('#question-1-no').on('click', function() {
            $question1.hide();
            $resultStrength.show();
        });

        // Event handler for going back from the second question
        $('#question-2 .go-back').on('click', function() {
            $question2.hide();
            $question1.show();
        });

        // Event handlers for answering the second question
        $('#question-2-yes').on('click', function() {
            $question2.hide();
            $resultInjury.show();
        });

        $('#question-2-no').on('click', function() {
            $question2.hide();
            $resultPhysio.show();
        });

        // Event handlers for going back from the results
        $('#result-injury .go-back').on('click', function() {
            $resultInjury.hide();
            $question2.show();
        });

        $('#result-physio .go-back').on('click', function() {
            $resultPhysio.hide();
            $question2.show();
        });
    };
// });


// WEBPACK FOOTER //
// ./scripts/partials/injury-form.js